import { ReactComponent as PencilIcon } from 'assets/icons/pencil.svg';

import styles from './scss/ModalMockFillButton.module.scss';

interface IModalMockFillButton {
  onClick: () => void,
  disabled?: boolean,
}

function ModalMockFillButton({
  onClick,
  disabled,
}: IModalMockFillButton) {
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
      aria-label="Fill mock data"
      title="Fill mock data"
    >
      <PencilIcon />
    </button>
  );
}

ModalMockFillButton.defaultProps = {
  disabled: false,
};

export default ModalMockFillButton;
